<template>
  <div
    class="side-menu opacity-0 bg-custom-secondary"
    style="
      background-image: url(/fe/asset/img/Rectangle.png);
      background-size: cover;
      border-radius: 30px 0px 0px 30px;
    "
  >
    <div class="overlay"></div>
    <div class="inner-wrapper">
      <span class="btn-close" id="btn_sideNavClose"><i></i><i></i></span>
      <nav class="side-nav w-100">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href="/">Beranda</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link collapsePagesSideMenu"
              data-toggle="collapse"
              href="#sideNavPages1"
            >
              Layanan <i class="fas fa-chevron-down"></i>
            </a>
            <div id="sideNavPages1" class="collapse sideNavPages">
              <ul class="navbar-nav mt-2">
                <li class="nav-item">
                  <a class="nav-link" href="/layanan-permohonan-daya"
                    >Dukungan Daya Sementara</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/layanan-iuptl"
                    >Pelaporan IUPTLS/IUPTLU/IUJPTL</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/layanan-suket"
                    >Permohonan Surat Keterangan</a
                  >
                </li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="/sebaran-spklu">Peta SPKL</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="/peraturan">Peraturan</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="">FAQ</a>
          </li>

          <li class="nav-item" v-if="!authStore.isAuthenticated">
            <a
              href="/login"
              class="nav-link btn btn-warning btn-sm bg-custom w-100 fw-bold"
            >
              <strong> Masuk / Daftar </strong></a
            >
          </li>

          <li class="nav-item" v-else>
            <a
              class="nav-link collapsePagesSideMenu btn btn-warning btn-sm bg-custom w-100 fw-bold"
              data-toggle="collapse"
              href="#sideNavPages22"
            >
              Dashboard Saya <i class="fas fa-chevron-down"></i>
            </a>
            <div id="sideNavPages22" class="collapse sideNavPages">
              <ul class="navbar-nav mt-2">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="javascript:void(0)"
                    @click="goToDashboard"
                    >Dashboard</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    href="javascript:void(0)"
                    @click="goToProfile"
                    >Profil</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)" @click="logout"
                    >Logout</a
                  >
                </li>
              </ul>
            </div>
          </li>

          <!-- <li class="nav-item dropdown position-relative" v-else>
            <a
              class=""
              href="javascript:void(0)"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src="/fe/asset/img/user-profile.png"
                style="max-width: 45px; cursor: pointer"
                class="mt-3 mb-3 ml-2 cursor-pointer dropdown-toggle"
                alt=""
              />
            </a>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                href="javascript:void(0)"
                @click="goToDashboard"
                >Dashboard</a
              >
              <a class="dropdown-item" href="">Profil</a>
              <a class="dropdown-item" href="" @click="logout">Keluar</a>
            </div>
          </li> -->
        </ul>
      </nav>
      <div class="side-footer w-100">
        <ul class="social-icons-simple white top40">
          <li>
            <a href="javascript:void(0)" class="facebook"
              ><i class="fab fa-facebook-f"></i>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" class="twitter"
              ><i class="fab fa-twitter"></i>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" class="insta"
              ><i class="fab fa-instagram"></i>
            </a>
          </li>
        </ul>
        <p class="whitecolor">&copy; © 2023 Pemerintah Provinsi DKI Jakarta</p>
      </div>
    </div>
  </div>
  <div id="close_side_menu" class="tooltip"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useAuthStore } from "@/store/auth";
import JwtService from "@/core/services/JwtService";

export default defineComponent({
  name: "SideMenu",
  setup() {
    const authStore = useAuthStore();

    const logout = async () => {
      await authStore.logout();
      // window.location.reload();
    };

    const goToDashboard = () => {
      if (authStore.isAuthenticated) {
        const rediirectAdmin =
          process.env.VUE_APP_ADMIN_URL_REDIRECT + JwtService.getToken();
        window.location.href = rediirectAdmin;
      } else {
        window.location.href = "/login";
      }
    };

    const goToProfile = () => {
      if (authStore.isAuthenticated) {
        const rediirectAdmin =
          process.env.VUE_APP_ADMIN_URL_REDIRECT +
          JwtService.getToken() +
          "&page=profile";
        // console.log(rediirectAdmin);
        window.location.href = rediirectAdmin;
      } else {
        window.location.href = "/login";
      }
    };

    return {
      logout,
      authStore,
      goToDashboard,
      goToProfile,
    };
  },
});
</script>
